(function () {
  'use strict';

  var COMPARE_ENABLED = false;
  var STORAGE_KEY = 'pctCompareProductsV1';
  var MAX_PRODUCTS = 3;

  function readProducts() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter(function (item) {
        return item && item.id && item.title && item.url;
      }).slice(0, MAX_PRODUCTS) : [];
    } catch (error) {
      return [];
    }
  }

  function writeProducts(products) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (error) {
      /* Le comparateur reste utilisable pendant la page si le stockage est bloqué. */
    }
  }

  function productFromButton(button) {
    return {
      id: String(button.dataset.productId || ''),
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || '',
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || '',
      vendor: button.dataset.productVendor || 'Non renseignée',
      type: button.dataset.productType || 'Non renseigné',
      sku: button.dataset.productSku || 'Non renseignée',
      stock: button.dataset.productStock || 'Non renseigné',
      available: button.dataset.productAvailable === 'true'
    };
  }

  function safeUrl(value) {
    return /^(?:\/|https?:\/\/)/i.test(value || '') ? value : '#';
  }

  function createTextElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    element.textContent = text || '';
    return element;
  }

  function addComparisonRow(list, label, value, className) {
    var row = document.createElement('div');
    row.className = 'pct-compare-card__row';
    row.appendChild(createTextElement('dt', '', label));
    row.appendChild(createTextElement('dd', className || '', value));
    list.appendChild(row);
  }

  function createComparisonCard(product, removeProduct) {
    var article = document.createElement('article');
    article.className = 'pct-compare-card';

    var remove = createTextElement('button', 'pct-compare-card__remove', '×');
    remove.type = 'button';
    remove.setAttribute('aria-label', 'Retirer ' + product.title + ' de la comparaison');
    remove.addEventListener('click', function () { removeProduct(product.id); });
    article.appendChild(remove);

    var visual = document.createElement('div');
    visual.className = 'pct-compare-card__image';
    if (product.image) {
      var image = document.createElement('img');
      image.src = safeUrl(product.image);
      image.alt = '';
      image.loading = 'lazy';
      visual.appendChild(image);
    }
    article.appendChild(visual);

    var body = document.createElement('div');
    body.className = 'pct-compare-card__body';
    var heading = document.createElement('h3');
    var titleLink = createTextElement('a', '', product.title);
    titleLink.href = safeUrl(product.url);
    heading.appendChild(titleLink);
    body.appendChild(heading);

    var details = document.createElement('dl');
    addComparisonRow(details, 'Prix', product.price);
    addComparisonRow(details, 'Disponibilité', product.stock, product.available ? 'is-available' : 'is-unavailable');
    addComparisonRow(details, 'Marque', product.vendor);
    addComparisonRow(details, 'Type', product.type);
    addComparisonRow(details, 'Référence', product.sku);
    body.appendChild(details);

    var link = createTextElement('a', 'pct-compare-card__link', 'Voir le produit');
    link.href = safeUrl(product.url);
    body.appendChild(link);
    article.appendChild(body);
    return article;
  }

  function initComparator() {
    var dock = document.querySelector('[data-pct-compare-dock]');
    var dialog = document.querySelector('[data-pct-compare-dialog]');
    if (!dock || !dialog) return;

    var grid = dialog.querySelector('[data-pct-compare-grid]');
    var status = dialog.querySelector('[data-pct-compare-status]');
    var count = dock.querySelector('[data-pct-compare-count]');
    var products = readProducts();

    function refreshButtons() {
      document.querySelectorAll('[data-pct-compare]').forEach(function (button) {
        var selected = products.some(function (product) {
          return product.id === String(button.dataset.productId || '');
        });
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        var label = button.querySelector('[data-pct-compare-label]');
        if (label) label.textContent = selected ? 'Sélectionné' : 'Comparer';
      });
    }

    function renderGrid() {
      grid.replaceChildren();
      if (!products.length) {
        grid.appendChild(createTextElement('p', 'pct-compare-dialog__empty', 'Sélectionnez des produits depuis la collection pour les comparer.'));
      } else {
        products.forEach(function (product) {
          grid.appendChild(createComparisonCard(product, removeProduct));
        });
      }
      status.textContent = products.length + (products.length > 1 ? ' produits sélectionnés' : ' produit sélectionné');
    }

    function saveAndRender() {
      writeProducts(products);
      dock.hidden = products.length === 0;
      count.textContent = products.length + '/' + MAX_PRODUCTS;
      refreshButtons();
      if (dialog.hasAttribute('open')) renderGrid();
    }

    function removeProduct(id) {
      products = products.filter(function (product) { return product.id !== String(id); });
      saveAndRender();
    }

    function toggleProduct(button) {
      var candidate = productFromButton(button);
      var existingIndex = products.findIndex(function (product) { return product.id === candidate.id; });
      if (existingIndex >= 0) {
        products.splice(existingIndex, 1);
      } else if (products.length < MAX_PRODUCTS) {
        products.push(candidate);
      } else {
        dock.classList.remove('is-limit');
        void dock.offsetWidth;
        dock.classList.add('is-limit');
        window.setTimeout(function () { dock.classList.remove('is-limit'); }, 450);
        return;
      }
      saveAndRender();
    }

    function openDialog() {
      renderGrid();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    function closeDialog() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    document.addEventListener('click', function (event) {
      var compareButton = event.target.closest('[data-pct-compare]');
      if (!compareButton) return;
      event.preventDefault();
      event.stopPropagation();
      toggleProduct(compareButton);
    }, true);

    document.querySelectorAll('[data-pct-compare-open]').forEach(function (button) {
      button.addEventListener('click', openDialog);
    });
    document.querySelectorAll('[data-pct-compare-close]').forEach(function (button) {
      button.addEventListener('click', closeDialog);
    });
    document.querySelectorAll('[data-pct-compare-clear]').forEach(function (button) {
      button.addEventListener('click', function () {
        products = [];
        saveAndRender();
        if (dialog.hasAttribute('open')) renderGrid();
      });
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && dialog.hasAttribute('open')) closeDialog();
    });

    saveAndRender();
  }

  function initMobileListBars() {
    document.querySelectorAll('[data-pct-mobile-listbar]').forEach(function (bar) {
      var scope = bar.closest('.pct-collection, [data-pct-search-filters]') || document;
      var filterToggle = scope.querySelector('[data-pct-filter-toggle], [data-pct-search-filter-toggle]') ||
        document.querySelector('[data-pct-filter-toggle], [data-pct-search-filter-toggle]');
      var sortSelect = scope.querySelector('[data-pct-sort-by], [data-pct-search-sort]') ||
        document.querySelector('[data-pct-sort-by], [data-pct-search-sort]');

      var filterButton = bar.querySelector('[data-pct-mobile-open-filters]');
      var sortButton = bar.querySelector('[data-pct-mobile-open-sort]');

      if (filterButton && filterToggle) {
        filterButton.addEventListener('click', function () { filterToggle.click(); });
      }

      if (sortButton && filterToggle && sortSelect) {
        sortButton.addEventListener('click', function () {
          if (filterToggle.getAttribute('aria-expanded') !== 'true') filterToggle.click();
          window.setTimeout(function () {
            sortSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
            sortSelect.focus({ preventScroll: true });
          }, 240);
        });
      }
    });
  }

  function initMobileCartBars() {
    document.querySelectorAll('[data-pct-mobile-cartbar]').forEach(function (bar) {
      var countNode = bar.querySelector('[data-pct-mobile-cartbar-count]');
      var cartJsonUrl = bar.dataset.cartJsonUrl || '/cart.js';
      var refreshTimers = [];

      function applyCount(value) {
        var count = Math.max(0, parseInt(value, 10) || 0);
        var isMobile = window.matchMedia('(max-width: 749px)').matches;

        if (countNode) countNode.textContent = String(count);
        bar.hidden = !isMobile || count === 0;
        bar.setAttribute(
          'aria-label',
          'Voir le panier : ' + count + ' article' + (count === 1 ? '' : 's')
        );
        document.body.classList.toggle('pct-has-mobile-cartbar', isMobile && count > 0);

        var copy = bar.querySelector('.pct-mobile-cartbar__copy small');
        if (copy) copy.innerHTML = '<span data-pct-mobile-cartbar-count>' + count + '</span> article' + (count === 1 ? '' : 's');
        countNode = bar.querySelector('[data-pct-mobile-cartbar-count]');
      }

      function refresh() {
        return fetch(cartJsonUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart request failed');
            return response.json();
          })
          .then(function (cart) {
            applyCount(cart.item_count);
          })
          .catch(function () {
            applyCount(bar.dataset.initialCartCount || 0);
          });
      }

      function scheduleRefresh() {
        refreshTimers.forEach(function (timer) { window.clearTimeout(timer); });
        refreshTimers = [250, 800, 1600].map(function (delay) {
          return window.setTimeout(refresh, delay);
        });
      }

      window.addEventListener('resize', function () {
        var current = countNode ? countNode.textContent : bar.dataset.initialCartCount;
        applyCount(current);
      }, { passive: true });
      window.addEventListener('pageshow', refresh);
      window.addEventListener('focus', refresh);

      document.addEventListener('cart:updated', function (event) {
        var cart = event.detail && event.detail.cart;
        if (cart && Number.isFinite(Number(cart.item_count))) {
          applyCount(cart.item_count);
        } else {
          refresh();
        }
      });

      document.addEventListener('click', function (event) {
        if (event.target.closest(
          'form[action*="/cart/add"] button[name="add"], ' +
          '.mini-cart__remove-item, .custom-selector-qty--minus, ' +
          '.custom-selector-qty--add, [data-cart-remove], [data-remove-item]'
        )) scheduleRefresh();
      }, true);

      applyCount(bar.dataset.initialCartCount || 0);
      refresh();
    });
  }

  function initMobileProductBar() {
    var bar = document.querySelector('[data-pct-mobile-productbar]');
    var form = document.querySelector('#addToCartForm');
    if (!bar || !form) return;

    var mobileButton = bar.querySelector('[data-pct-mobile-product-add]');
    var mobileButtonLabel = mobileButton && mobileButton.querySelector('span');
    var mobilePrice = bar.querySelector('[data-pct-mobile-product-price]');
    var mobileStock = bar.querySelector('[data-pct-mobile-product-stock]');
    var mobileCartLink = bar.querySelector('[data-pct-mobile-cart-link]');
    var mobileCartCount = bar.querySelector('[data-pct-mobile-cart-count]');
    var variantsNode = bar.querySelector('[data-pct-mobile-product-variants]');
    var cartJsonUrl = bar.dataset.cartJsonUrl || '/cart.js';
    var variants = {};
    var countAnimationTimer;
    var addingTimer;
    var visibilityFrame;
    var cartRefreshTimers = [];
    var cartRequestSequence = 0;
    var cartLastAppliedRequest = 0;

    try {
      JSON.parse(variantsNode ? variantsNode.textContent : '[]').forEach(function (variant) {
        variants[String(variant.id)] = variant;
      });
    } catch (error) {
      variants = {};
    }

    function sourceButton() {
      return form.querySelector('#addToCart, #addToCartProduct, button[name="add"]');
    }

    function selectedVariant() {
      var selector = form.querySelector('select[name="id"], input[name="id"]');
      if (selector && variants[String(selector.value)]) {
        return variants[String(selector.value)];
      }

      try {
        var idFromUrl = new URL(window.location.href).searchParams.get('variant');
        if (idFromUrl && variants[String(idFromUrl)]) return variants[String(idFromUrl)];
      } catch (error) {}

      var firstId = Object.keys(variants)[0];
      return firstId ? variants[firstId] : null;
    }

    function isPreorder(variant) {
      return Boolean(
        variant &&
        variant.available &&
        variant.tracked &&
        Number(variant.quantity) <= 0 &&
        variant.policy === 'continue'
      );
    }

    function sync() {
      var source = sourceButton();
      var variant = selectedVariant();
      var unavailable = variant ? !variant.available : (!source || source.disabled || source.classList.contains('no-stock'));
      var preorder = isPreorder(variant);

      if (variant && mobilePrice) mobilePrice.textContent = variant.price;
      if (mobileButton) mobileButton.disabled = unavailable;
      if (mobileButtonLabel && !bar.classList.contains('is-adding')) {
        mobileButtonLabel.textContent = unavailable ? 'Épuisé' : (preorder ? 'Précommandez' : 'Ajouter au panier');
      }

      bar.classList.toggle('is-preorder', preorder);
      bar.classList.toggle('is-unavailable', unavailable);

      if (mobileStock) {
        mobileStock.textContent = unavailable ? 'Épuisé' : (preorder ? 'Disponible en précommande' : 'En stock');
        mobileStock.classList.toggle('is-available', !unavailable && !preorder);
        mobileStock.classList.toggle('is-unavailable', unavailable);
        mobileStock.classList.toggle('is-preorder', preorder);
      }
    }

    function setCartCount(value, animate) {
      var count = Math.max(0, parseInt(value, 10) || 0);
      var previous = mobileCartCount ? parseInt(mobileCartCount.textContent, 10) || 0 : 0;

      if (mobileCartCount) {
        mobileCartCount.textContent = String(count);
        mobileCartCount.hidden = count === 0;
      }
      if (mobileCartLink) {
        mobileCartLink.setAttribute(
          'aria-label',
          'Voir le panier : ' + count + ' article' + (count === 1 ? '' : 's')
        );
      }

      document.querySelectorAll('.cart-count').forEach(function (counter) {
        if (counter.textContent.trim() !== String(count)) counter.textContent = String(count);
        counter.classList.toggle('hidden-count', count === 0);
      });

      if (animate && mobileCartCount && count !== previous) {
        window.clearTimeout(countAnimationTimer);
        mobileCartCount.classList.remove('is-bumping');
        void mobileCartCount.offsetWidth;
        mobileCartCount.classList.add('is-bumping');
        countAnimationTimer = window.setTimeout(function () {
          mobileCartCount.classList.remove('is-bumping');
        }, 650);
      }
    }

    function refreshCartCount(animate) {
      var requestId = ++cartRequestSequence;

      return fetch(cartJsonUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then(function (cart) {
          if (requestId < cartLastAppliedRequest) return cart.item_count;
          cartLastAppliedRequest = requestId;
          setCartCount(cart.item_count, animate);
          return cart.item_count;
        })
        .catch(function () {
          return null;
        });
    }

    function scheduleCartRefresh() {
      cartRefreshTimers.forEach(function (timer) { window.clearTimeout(timer); });
      cartRefreshTimers = [250, 800, 1600, 2800].map(function (delay) {
        return window.setTimeout(function () { refreshCartCount(true); }, delay);
      });
    }

    function stopAddingState() {
      window.clearTimeout(addingTimer);
      bar.classList.remove('is-adding');
      sync();
    }

    function syncVisibility() {
      visibilityFrame = null;
      /* Permanente sur les fiches produit en mobile, masquée seulement lorsque
         la largeur repasse au format tablette/ordinateur. */
      bar.hidden = !window.matchMedia('(max-width: 749px)').matches;
    }

    function requestVisibilitySync() {
      if (visibilityFrame) return;
      visibilityFrame = window.requestAnimationFrame(syncVisibility);
    }

    mobileButton.addEventListener('click', function () {
      var source = sourceButton();
      if (!source || source.disabled || mobileButton.disabled) return;

      bar.classList.add('is-adding');
      if (mobileButtonLabel) mobileButtonLabel.textContent = 'Ajout…';
      source.click();
      scheduleCartRefresh();
      window.clearTimeout(addingTimer);
      addingTimer = window.setTimeout(stopAddingState, 1400);
    });

    form.addEventListener('change', function () {
      window.setTimeout(sync, 0);
      window.setTimeout(sync, 100);
    });

    form.addEventListener('click', function (event) {
      if (event.target.closest('.swatch-element, [data-value], [data-option-value]')) {
        window.setTimeout(sync, 0);
        window.setTimeout(sync, 120);
      }
    });

    ['variant:change', 'variant:changed', 'variantChange'].forEach(function (eventName) {
      document.addEventListener(eventName, sync);
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest(
        'form[action*="/cart/add"] button[name="add"], ' +
        '.mini-cart__remove-item, .custom-selector-qty--minus, ' +
        '.custom-selector-qty--add, [data-cart-remove], [data-remove-item]'
      )) {
        scheduleCartRefresh();
      }
    });

    document.addEventListener('submit', function (event) {
      if (event.target.matches('form[action*="/cart/add"], form[action*="/cart"]')) {
        scheduleCartRefresh();
      }
    }, true);

    document.addEventListener('change', function (event) {
      if (event.target.matches('.mini-cart__item input[name="qty"], .cart__row input[name="updates[]"]')) {
        scheduleCartRefresh();
      }
    });

    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail && event.detail.cart;
      if (cart && Number.isFinite(Number(cart.item_count))) {
        setCartCount(Number(cart.item_count), true);
      } else {
        refreshCartCount(true);
      }
    });
    window.addEventListener('resize', requestVisibilitySync, { passive: true });
    window.addEventListener('focus', function () { refreshCartCount(false); });
    window.addEventListener('pageshow', function () { refreshCartCount(false); });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshCartCount(false);
    });

    /* Le thème met déjà à jour ses compteurs après certaines opérations AJAX.
       On les observe également afin que le badge sticky suive immédiatement. */
    document.querySelectorAll('.cart-count').forEach(function (counter) {
      new MutationObserver(function () {
        var value = parseInt(counter.textContent, 10);
        var current = mobileCartCount ? parseInt(mobileCartCount.textContent, 10) : NaN;
        if (Number.isFinite(value) && value !== current) setCartCount(value, true);
      }).observe(counter, { childList: true, characterData: true, subtree: true });
    });

    sync();
    refreshCartCount(false);
    requestVisibilitySync();
  }

  function initCartChatSuppression() {
    if (!document.body) return;

    var hiddenElements = [];
    var syncFrame = 0;

    var chatSelector = [
      '#ShopifyChat',
      '#shopify-chat',
      'shopify-chat',
      'shopify-inbox',
      '.shopify-chat',
      '[data-shopify-chat]',
      '[id*="shopify-chat" i]',
      '[class*="shopify-chat" i]',
      '[id*="chat-widget" i]',
      '[class*="chat-widget" i]',
      '[id*="chat-button" i]',
      '[class*="chat-button" i]',
      '[id*="inbox-widget" i]',
      '[class*="inbox-widget" i]',
      '.qstomy-iframe',
      '.qstomy-instant-panel',
      '.intercom-lightweight-app',
      '.intercom-app',
      '.tidio-chat',
      '#tidio-chat',
      '.crisp-client',
      '.gorgias-chat-key',
      '#gorgias-chat-container',
      '#chatra',
      '#smartsupp-widget-container',
      'iframe[title*="chat" i]',
      'iframe[title*="discussion" i]',
      'iframe[title*="message" i]',
      'iframe[src*="shopifychat" i]',
      'iframe[src*="shopify-chat" i]',
      'iframe[src*="inbox" i]',
      'iframe[src*="chat" i]'
    ].join(',');

    function hideChatElement(element) {
      if (!element || element.nodeType !== 1) return;

      var target = element;
      var parent = element.parentElement;

      /* Lorsqu'un iframe est seul dans un petit conteneur flottant, masquer
         également ce conteneur afin qu'il ne conserve aucune zone cliquable. */
      if (element.tagName === 'IFRAME' && parent && parent !== document.body) {
        var parentStyle = window.getComputedStyle(parent);
        if (parentStyle.position === 'fixed' || parentStyle.position === 'sticky') {
          target = parent;
        }
      }

      if (target.getAttribute('data-pct-hidden-cart-chat') === 'true') return;

      target.setAttribute('data-pct-chat-display', target.style.getPropertyValue('display') || '');
      target.setAttribute('data-pct-chat-visibility', target.style.getPropertyValue('visibility') || '');
      target.setAttribute('data-pct-chat-pointer-events', target.style.getPropertyValue('pointer-events') || '');
      target.setAttribute('data-pct-chat-aria-hidden', target.getAttribute('aria-hidden') || '');
      target.setAttribute('data-pct-hidden-cart-chat', 'true');
      target.setAttribute('aria-hidden', 'true');
      target.style.setProperty('display', 'none', 'important');
      target.style.setProperty('visibility', 'hidden', 'important');
      target.style.setProperty('pointer-events', 'none', 'important');
      hiddenElements.push(target);
    }

    function suppressChat(root) {
      var scope = root && root.nodeType === 1 ? root : document;

      if (scope.matches && scope.matches(chatSelector)) hideChatElement(scope);
      if (scope.querySelectorAll) {
        scope.querySelectorAll(chatSelector).forEach(hideChatElement);
      }
    }

    function suppressBottomLeftMobileBubble() {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      document.querySelectorAll('body *').forEach(function (element) {
        if (element.getAttribute('data-pct-hidden-cart-chat') === 'true') return;
        if (element.closest('.mini-cart-modal, .mini-cart-modal-overlay, #mini-cart__v2')) return;
        if (element.closest('.site-header, .header, .main-content, .site-footer, footer')) return;
        if (element.matches('.back-to-top, [class*="back-to-top" i], [id*="back-to-top" i], [data-pct-mobile-productbar], [data-pct-mobile-cartbar]')) return;

        var style = window.getComputedStyle(element);
        if (style.position !== 'fixed') return;

        var rect = element.getBoundingClientRect();
        var bottomGap = window.innerHeight - rect.bottom;
        var isBottomLeft = rect.left >= -10 && rect.left <= 110 && bottomGap >= -10 && bottomGap <= 180;
        var isBubbleSize = rect.width >= 28 && rect.width <= 180 && rect.height >= 28 && rect.height <= 180;
        var marker = ((element.id || '') + ' ' + (element.className || '') + ' ' + element.tagName).toLowerCase();
        var looksLikeWidget = element.tagName === 'IFRAME' || element.tagName.indexOf('-') !== -1 ||
          element.shadowRoot || /chat|inbox|message|messenger|qstomy|support|help|contact/.test(marker) ||
          (parseInt(style.zIndex, 10) || 0) >= 1000;

        if (isBottomLeft && isBubbleSize && looksLikeWidget) hideChatElement(element);
      });
    }

    function cartContextIsOpen() {
      return document.body.classList.contains('template-cart') || Boolean(document.querySelector(
        '.mini-cart-modal.open, .mini-cart-modal-overlay.open, #mini-cart__v2.visible'
      ));
    }

    function restoreChat() {
      hiddenElements.forEach(function (element) {
        if (!element || !element.isConnected) return;

        var display = element.getAttribute('data-pct-chat-display') || '';
        var visibility = element.getAttribute('data-pct-chat-visibility') || '';
        var pointerEvents = element.getAttribute('data-pct-chat-pointer-events') || '';
        var ariaHidden = element.getAttribute('data-pct-chat-aria-hidden') || '';

        if (display) element.style.setProperty('display', display);
        else element.style.removeProperty('display');
        if (visibility) element.style.setProperty('visibility', visibility);
        else element.style.removeProperty('visibility');
        if (pointerEvents) element.style.setProperty('pointer-events', pointerEvents);
        else element.style.removeProperty('pointer-events');
        if (ariaHidden) element.setAttribute('aria-hidden', ariaHidden);
        else element.removeAttribute('aria-hidden');

        element.removeAttribute('data-pct-hidden-cart-chat');
        element.removeAttribute('data-pct-chat-display');
        element.removeAttribute('data-pct-chat-visibility');
        element.removeAttribute('data-pct-chat-pointer-events');
        element.removeAttribute('data-pct-chat-aria-hidden');
      });
      hiddenElements = [];
    }

    function syncCartChat() {
      syncFrame = 0;
      var active = cartContextIsOpen();
      document.documentElement.classList.toggle('pct-cart-no-chat', active);

      if (active) {
        suppressChat(document);
        suppressBottomLeftMobileBubble();
      } else if (hiddenElements.length) {
        restoreChat();
      }
    }

    function requestCartChatSync() {
      if (syncFrame) return;
      syncFrame = window.requestAnimationFrame(syncCartChat);
    }

    syncCartChat();

    var observer = new MutationObserver(function () {
      requestCartChatSync();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    document.querySelectorAll('.mini-cart-modal, .mini-cart-modal-overlay, #mini-cart__v2').forEach(function (element) {
      new MutationObserver(requestCartChatSync).observe(element, {
        attributes: true,
        attributeFilter: ['class']
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.cart-toggle, #mini-cart-close-modal, .mini-cart-modal-overlay')) {
        window.setTimeout(syncCartChat, 350);
      }
    }, true);

    window.addEventListener('resize', requestCartChatSync, { passive: true });
    window.setTimeout(syncCartChat, 500);
    window.setTimeout(syncCartChat, 1500);
    window.setTimeout(syncCartChat, 5000);
  }

  function initMobileTrustStrip() {
    document.querySelectorAll('.pct-trust-strip').forEach(function (strip) {
      var track = strip.querySelector('.pct-trust-strip__inner');
      var items = track ? Array.prototype.slice.call(track.querySelectorAll('.pct-trust-item:not([data-pct-trust-clone])')) : [];
      if (!track || items.length < 2 || track.getAttribute('data-pct-trust-ready') === 'true') return;

      track.setAttribute('data-pct-trust-ready', 'true');
      track.setAttribute('aria-live', 'off');

      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('data-pct-trust-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      /* Environ 5,5 secondes de lecture par engagement, avec une vitesse
         parfaitement linéaire et aucune remise à zéro visible. */
      track.style.setProperty('--pct-trust-loop-duration', (items.length * 5.5) + 's');
      track.classList.add('is-continuous');
    });
  }

  function start() {
    if (COMPARE_ENABLED) {
      initComparator();
    } else {
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
    }
    initMobileListBars();
    initMobileCartBars();
    initMobileProductBar();
    initCartChatSuppression();
    initMobileTrustStrip();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
